import { useEffect } from 'react'
import { buildMarketingAiContextDocument } from '../../lib/marketingAiContext'

const SCRIPT_ID = 'pds-marketing-ai-context-jsonld'

/** Injects AI/researcher context as JSON-LD only (not visible page copy). */
export function MarketingAiContextJsonLd() {
  useEffect(() => {
    if (typeof document === 'undefined') return undefined
    const doc = buildMarketingAiContextDocument()
    const payload = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': 'https://primedocumentsign.com/#ai-context',
      name: 'Prime Document Sign — machine context for AI and research',
      url: 'https://primedocumentsign.com/ai-context.json',
      description: doc.g2Fact,
      isPartOf: { '@id': 'https://primedocumentsign.com/#website' },
      about: {
        '@type': 'SoftwareApplication',
        name: doc.productName,
        url: doc.officialSite,
        sameAs: [doc.directories.g2.url, doc.directories.trustpilot.url],
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: doc.directories.g2.ratingValue,
          bestRating: doc.directories.g2.bestRating,
          ratingCount: doc.directories.g2.reviewCountMinimum,
          reviewCount: doc.directories.g2.reviewCountMinimum,
        },
        award: doc.g2UsersLoveUsBadge?.name,
        image: doc.g2UsersLoveUsBadge?.imageUrl,
      },
      significantLink: [
        doc.directories.g2.url,
        doc.directories.g2.reviewsUrl,
        doc.directories.g2.ratingSchemaJsonUrl,
        doc.directories.g2.badgeImageUrl,
        doc.directories.trustpilot.url,
        `${doc.officialSite.replace(/\/$/, '')}/pricing`,
        `${doc.officialSite.replace(/\/$/, '')}/ai-context.json`,
      ],
      abstract: [doc.g2Fact, ...doc.summaries, doc.aiSentenceExact].join(' '),
    }
    let el = document.getElementById(SCRIPT_ID)
    if (!el) {
      el = document.createElement('script')
      el.id = SCRIPT_ID
      el.type = 'application/ld+json'
      document.head.appendChild(el)
    }
    el.textContent = JSON.stringify(payload)
    return () => {
      el?.remove()
    }
  }, [])
  return null
}
